import { FC, ReactNode } from "react";
import { Badge, BadgeClassNames } from "@app/shared/Badge";
import { SpecialtyGroupExceptionStatus } from "@app/exceptions/enums";

interface NetworkSubmissionStatusBadgeProps {
  status: SpecialtyGroupExceptionStatus;
  children: ReactNode;
}

const getBadgeClass = (status: SpecialtyGroupExceptionStatus): BadgeClassNames => {
  switch (status) {
    case SpecialtyGroupExceptionStatus.Approved:
      return "badge--success";
    case SpecialtyGroupExceptionStatus.Denied:
      return "badge--danger";
    case SpecialtyGroupExceptionStatus.Appealed:
    case SpecialtyGroupExceptionStatus.Submitted:
      return "badge--warning";
    case SpecialtyGroupExceptionStatus.None:
    case SpecialtyGroupExceptionStatus.Pending:
    case SpecialtyGroupExceptionStatus.Archived:
    case SpecialtyGroupExceptionStatus.Expired:
    default:
      return "badge--neutral";
  }
};

export const NetworkSubmissionStatusBadge: FC<NetworkSubmissionStatusBadgeProps> = ({ status, children }) => (
  <Badge badgeType={getBadgeClass(status)}>
    {children}
  </Badge>
);
